import { css } from "lit";
export const componentStyles = css `
:host {
  --sm-space: 1rem;
  --md-space: 2rem;
  --gap: var(--md-space);

  display: -ms-grid;

  display: grid;
  grid-gap: var(--gap);
  gap: var(--gap);
}

:host([data-header="hidden"]) header {
  display: none;
}

:host([data-item-count="false"]) .item-count {
  display: none;
}

::slotted(ul)::-webkit-scrollbar {
  display: none;
}

::slotted(ul) {
  list-style: none;

  --size: 150px;

  display: -ms-grid;

  display: grid;
  grid-auto-flow: column;
  grid-gap: calc(var(--gap) / 2);
  gap: calc(var(--gap) / 2);
  margin: 0;

  -webkit-padding-start: calc(var(--gap) / 2);

          padding-inline-start: calc(var(--gap) / 2);
  padding-right: var(--gap);
  padding-block: calc(var(--gap) / 2);

  overflow-x: auto;
  overscroll-behavior-inline: contain;
  -ms-scroll-snap-type: inline mandatory;
      scroll-snap-type: inline mandatory;
  scroll-padding-inline: var(--gap);
  scroll-behavior: smooth;

  -webkit-transition: scroll-left 0.3s ease;

  -o-transition: scroll-left 0.3s ease;

  transition: scroll-left 0.3s ease;

  scrollbar-width: none;
}

header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}

.rhs {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: var(--gap);
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  width: 100%;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

.item-count {
  font-family: var(--font-brand-bold-stack);
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.5;
}

button {
  background-color: transparent;
  border: none;
}

button > svg {
  color: var(--xdlColorText);
}

a {
  text-decoration: none;
  color: var(--xdlColorText);
}

@media (min-width: 1200px) {
  header {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
        -ms-flex-direction: row;
            flex-direction: row;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
  }

  .rhs {
    width: auto;
    -webkit-box-pack: unset;
        -ms-flex-pack: unset;
            justify-content: unset;
  }
}
`;
//# sourceMappingURL=media-scroller.css.js.map